/*eslint-disable no-var */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */ import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import { Card, Col, Form, Row, Container } from 'react-bootstrap';
import CoverageSlider from '../coverage/slidercoverage';

import EnableIntegration from '../../../shared/EnableIntegration';
import MemberSummary from '../../../api/MemberSummary';
import Dependent from '../../../api/Dependent';
import MemberCoverageSummary from '../../../api/MemberCoverageSummary';
import ClaimsList from '../../../api/ClaimsList';

import CookiesService from '../../../shared/CookiesService';
import RetryAPI from '../../../api/RetryAPI';
import HttpErrorHandler from '../../../errorhandling/HttpErrorHandler';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../../errorhandling/HttpErrorCodes';
import APIEndpoints from '../../../api/APIEndpoints';
import { axiosInstance } from '../../../../api/axios';
import Skeleton from '../../common/skeleton';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';
import { withTranslation } from 'react-i18next';

let list = [];
let memberName = '';

const MenuItem = ({ text, selected }) => {
  return <div className={`menu-item ${selected ? 'active' : ''}`}>{text}</div>;
};

export const Menu = (list, selected) =>
  list.map((el) => {
    const { name } = el;
    return <MenuItem text={name} key={name} selected={selected} />;
  });

const Arrow = ({ text, className }) => {
  return (
    <div
      className={className}
      tabIndex={0}
      aria-label={text === '<' ? 'Previous' : 'Next'}
    >
      {text}
    </div>
  );
};

export const ArrowLeft = Arrow({ text: '<', className: 'arrow-prev' });
export const ArrowRight = Arrow({ text: '>', className: 'arrow-next' });
export const ArrowHide = Arrow({ text: '', className: 'arrow-hide' });

class MenuTabs extends Component {
  state = {
    alignCenter: false,
    clickWhenDrag: false,
    dragging: true,
    hideArrows: true,
    hideSingleArrow: true,
    itemsCount: list.length,
    scrollToSelected: false,
    selected: '',
    translate: 0,
    transition: 0.3,
    wheel: true,
    selectedFlag: true,
    clientError: false,
    serverError: false,
    isNotFound: false,
    isAPIFailed: false,
  };

  cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  constructor(props) {
    super(props);
    list = [];

    EnableIntegration.ToggleAPIIntegration(EnableIntegration.enableIntegration);

    //if (!EnableIntegration.isAPIIntegrationEnabled()) {
    //list.push({ name: 'FAMILY (16)' },
    //{ name: 'Dennis (Member) ' },
    //{ name: 'Jane (Spouse) ' },
    //{ name: 'Kaylee (Dependent)  ' },
    //{ name: 'Edward (Dependent) ' },
    //{ name: 'Emily (Dependent)  ' },
    //{ name: 'Josh (Dependent)' });
    //}
    //else {
    console.log(
      'No of dependents coverage: ',
      MemberSummary.getNumberOfDependents(),
    );
    if (MemberSummary.getNumberOfDependents() == 0)
      list.push({
        name:
          MemberSummary.getFirstName() +
          ' (' +
          MemberSummary.getMemberType() +
          ')',
      });
    else {
      //eslint-disable-next-line no-useless-concat
      list.push({
        name:
          'FAMILY' + ' (' + (MemberSummary.getNumberOfDependents() + 1) + ')',
      });
      list.push({
        name:
          MemberSummary.getFirstName() +
          ' (' +
          MemberSummary.getMemberType() +
          ')',
      });
      for (
        let iIndex = 0;
        iIndex < MemberSummary.getNumberOfDependents();
        iIndex++
      ) {
        if (Dependent.getMemberOID(iIndex) !== null) {
          list.push({
            name:
              Dependent.getFirstName(iIndex) +
              ' (' +
              Dependent.getRelationshipToMember(iIndex) +
              ')',
          });
        }
      }
    }
    //}

    this.menu = null;
    this.menuItems = Menu(list.slice(0, list.length), this.state.selected);
  }
  /*Get Accumulator Details  */
  getAccumulatorDetails = async (memberSeqID) => {
    let response;
    let oid = '';
    let memType = '';

    if (memberSeqID == 0 || memberSeqID == 1) {
      memberSeqID = 0;
      oid = MemberSummary.getSelectedMemOID(memberSeqID);
      memType = MemberSummary.getSelectedMemType(memberSeqID);
      MemberSummary.memberSeqID = memberSeqID;
    } else {
      memberSeqID = memberSeqID - 1;
      oid = MemberSummary.getSelectedMemOID(memberSeqID);
      memType = MemberSummary.getSelectedMemType(memberSeqID);
      MemberSummary.memberSeqID = memberSeqID;
    }

    try {
      MemberCoverageSummary.setAccoumulatorDetails(null);

      const response = await axiosInstance.get(
        this.cacheBuster(
          APIEndpoints.getMemberAccumulatorResource() + memType + '/oid/' + oid,
        ),
      ); //+ '/year/2021'
      const memberAccumuDetailResp = response.data;

      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        if (memberSeqID == 0) {
          CookiesService.set(
            'MemberAccumlator',
            JSON.stringify(memberAccumuDetailResp),
          );
          MemberCoverageSummary.setAccoumulatorDetails(
            memberSeqID,
            memberAccumuDetailResp,
          );
          MemberCoverageSummary.setAccoumulatorDetails(
            memberSeqID + 1,
            memberAccumuDetailResp,
          );
        }
        //else {
        //MemberCoverageSummary.setAccoumulatorDetails(memberSeqID + 1, memberAccumuDetailResp);
        //}
      } else {
        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
        RetryAPI.setErrorCode(response.status);
      }
    } catch (error) {
      let errorMessage = '';
      //var requestAborted = '';

      console.log('Member Accumulator Details Exception: ', error);
      if (error) {
        errorMessage = error.toString();
        //requestAborted = errorMessage.match(/aborted/i);
        RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
      }
      if (error.response) {
        RetryAPI.setErrorCode(error.response.status);
      }

      RetryAPI.incrementRetryCount();
      RetryAPI.setResponseReceived(false);
    }
    return response;
  };
  /*End of Accumulator Details */

  getMemberCoverageSummary = async (memberSeqID) => {
    let response;
    let currentDate;
    let memberCnt = 0;
    let bearerToken, refreshToken;
    let oid = '';
    let memType = '';

    if (MemberSummary.getNumberOfDependents() > 0)
      memberCnt = MemberSummary.getNumberOfDependents() + 2;
    else memberCnt = 1;

    MemberCoverageSummary.benefitPlan = new Array(memberCnt);
    MemberCoverageSummary.coverageType = new Array(memberCnt);

    if (memberSeqID == 0 || memberSeqID == 1) {
      memberSeqID = 0;
      MemberSummary.memberSeqID = memberSeqID;
      oid = MemberSummary.getSelectedMemOID(memberSeqID);
      memType = MemberSummary.getSelectedMemType(memberSeqID);
    } else {
      memberSeqID = memberSeqID - 1;
      oid = MemberSummary.getSelectedMemOID(memberSeqID);
      memType = MemberSummary.getSelectedMemType(memberSeqID);
      MemberSummary.memberSeqID = memberSeqID;
    }

    try {
      currentDate = new Date().toISOString().split('T')[0];

      MemberCoverageSummary.setMemberCoverage(null);
      console.log('MemberSeqID -->', memberSeqID);
      console.log(
        'MemberSummary.getNumberOfDependents -->',
        MemberSummary.getNumberOfDependents(),
      );

      console.log(
        'Coverage URL: ',
        APIEndpoints.getMemberCoverageSummaryResource() +
          memType +
          '/oid/' +
          oid +
          '/covgeffectivedate/' +
          currentDate,
      );

      const response = await axiosInstance.get(
        //var EncrptedmemberCoverageSummaryResp  = await MemberCoverageSummaryAPI.get(
        this.cacheBuster(
          APIEndpoints.getMemberCoverageSummaryResource() +
            memType +
            '/oid/' +
            oid +
            '/covgeffectivedate/' +
            currentDate,
        ),
      );

      const memberCoverageSummaryDataResp = response.data;

      if (memberSeqID == 0) {
        CookiesService.set(
          'MemberCoverage',
          JSON.stringify(memberCoverageSummaryDataResp),
        );
        MemberCoverageSummary.setMemberCoverage(
          memberSeqID,
          memberCoverageSummaryDataResp,
        );
        MemberCoverageSummary.setMemberCoverage(
          memberSeqID + 1,
          memberCoverageSummaryDataResp,
        );
      } else {
        MemberCoverageSummary.setMemberCoverage(
          memberSeqID + 1,
          memberCoverageSummaryDataResp,
        );
      }
      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        MemberCoverageSummary.setPlansEnrolled(
          memberCoverageSummaryDataResp.Response.EligibilityCoverage[0]
            .MemberCoverage.length,
        );

        for (var iIndex = 0; iIndex < memberCnt; iIndex++) {
          MemberCoverageSummary.benefitPlan[iIndex] = new Array(
            MemberCoverageSummary.getPlansEnrolled(),
          );
          MemberCoverageSummary.coverageType[iIndex] = new Array(
            MemberCoverageSummary.getPlansEnrolled(),
          );
        }

        for (
          iIndex = 0;
          iIndex < MemberCoverageSummary.getPlansEnrolled();
          iIndex++
        ) {
          MemberCoverageSummary.setBenefitPlan(
            memberSeqID,
            iIndex,
            memberCoverageSummaryDataResp.Response.EligibilityCoverage[0]
              .MemberCoverage[iIndex].BenefitPlan,
          );
          MemberCoverageSummary.setCoverageType(
            memberSeqID,
            iIndex,
            memberCoverageSummaryDataResp.Response.EligibilityCoverage[0]
              .MemberCoverage[iIndex].CoverageType,
          );
        }
        RetryAPI.resetRetryCount();
        RetryAPI.setResponseReceived(true);
      } else {
        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
        RetryAPI.setErrorCode(response.status);
      }
    } catch (error) {
      let errorMessage = '';
      this.setState({ isAPIFailed: true });
      if (error.toString().includes('404')) {
        this.setState({ isNotFound: true });
      }
      if (error) {
        errorMessage = error.toString();
        //requestAborted = errorMessage.match(/aborted/i);
        RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
      }
      if (error.response) {
        console.log('Data: ', error.response.data);
        console.log('Header: ', error.response.headers);
        console.log('Status: ', error.response.status);
        RetryAPI.setErrorCode(error.response.status);
      }

      //if (axios.isCancel(error)) {
      //console.log('Previous request canceled, new request is send', error.message);
      //}
      console.log('Member Summary Exception: ', error);
      console.log('Member Coverage Summary Exception: ', error);
      RetryAPI.incrementRetryCount();
      RetryAPI.setResponseReceived(false);
    }
    return response;
  };

  async componentDidMount() {
    let getCoverage;
    let getAccums;

    console.log('Dashboard Coverage: ComponentDidMount');
    //resetting filter for claims list
    ClaimsList.setMemberName(null);
    ClaimsList.setClaimType(null);
    ClaimsList.setClaimStatus(null);

    this.setState({ selected: list[0].name });
    memberName = list[0].name;

    this.setState({ selectedFlag: false });

    MemberCoverageSummary.setSelectedItem(0);
    console.log(
      'MemberCoverageSummary.getSelectedItem(): ',
      MemberCoverageSummary.getSelectedItem(),
    );

    if (
      typeof MemberCoverageSummary.getMemberCoverage(
        MemberCoverageSummary.getSelectedItem(),
      ) === 'undefined'
    ) {
      RetryAPI.setResponseReceived(false);
      RetryAPI.resetRetryCount();
      while (RetryAPI.performRetry()) {
        getCoverage = await this.getMemberCoverageSummary(0);
        if (RetryAPI.getResponseReceived()) break;
      }

      if (RetryAPI.retryFailed()) {
        const errorCode = RetryAPI.getErrorCode();
        HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');
        this.setState({ selectedFlag: false }); //CREATE A NEW FLAG TO DISPLAY ERROR MESSAGE

        //Process Client Errors
        if (
          HttpErrorHandler.ProcessedClientErrors(
            errorCode,
            'view member coverage summary. ',
          )
        ) {
          console.log('INSIDE PROCESSED CLIENT ERRORS');
          this.setState({ clientError: true });
          this.setState({ selectedFlag: true });
        } else {
          //Handle Excpetion
          if (
            HttpErrorHandler.ProcessedException(
              errorCode,
              'We are unable to render your Coverage Summary now.',
            )
          ) {
            this.setState({ serverError: true });
          }
        }
      } else {
        RetryAPI.setResponseReceived(false);
        RetryAPI.resetRetryCount();
        while (RetryAPI.performRetry()) {
          getAccums = await this.getAccumulatorDetails(0);
          if (RetryAPI.getResponseReceived()) break;
        }

        if (RetryAPI.retryFailed()) {
          const errorCode = RetryAPI.getErrorCode();
          HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');
          this.setState({ selectedFlag: false }); //CREATE A NEW FLAG TO DISPLAY ERROR MESSAGE
          //EVERY COVERAGE WILL HAVE A ACCUMULATOR HENCE NO 404 ERROR CHECK REQUIRED
          //Process Client Errors
          if (
            HttpErrorHandler.ProcessedClientErrors(
              errorCode,
              'view accumulator details. ',
            )
          ) {
            console.log('INSIDE PROCESSED CLIENT ERRORS');
            this.setState({ clientError: true });
            this.setState({ selectedFlag: true });
          } else {
            //Handle Excpetion
            if (
              HttpErrorHandler.ProcessedException(
                errorCode,
                'We are unable to render your Coverage Summary now.',
              )
            ) {
              this.setState({ serverError: true });
            }
          }
        } else {
          this.setState({ selectedFlag: true });
        }
      }
    } else {
      this.setState({ selectedFlag: true });
    }
  }

  onSelect = async (key) => {
    let getCoverage;
    let getAccums;

    if (EnableIntegration.isAPIIntegrationEnabled()) {
      console.log(`onSelect: ${key}`);
      this.setState({ selected: key });
      console.log('KEY: ', key);
      memberName = key;
      this.setState({ selectedFlag: false });
      for (let iIndex = 0; iIndex < list?.length; iIndex++) {
        console.log('SELECTED: ', key);
        console.log('LOOPING: ', list[iIndex].name);
        if (list[iIndex].name == key) {
          MemberCoverageSummary.setSelectedItem(iIndex);
          console.log('LOOPING INDEX: ', iIndex);
          break;
        }
        console.log('onSelect');
      }
      console.log(
        'MemberCoverageSummary.getSelectedItem(): ',
        MemberCoverageSummary.getSelectedItem(),
      );
      this.setState({ clientError: false });

      console.log(
        'GET MEMBER COVERAGE: ',
        MemberCoverageSummary.getMemberCoverage(
          MemberCoverageSummary.getSelectedItem(),
        ),
      );
      RetryAPI.setResponseReceived(false);
      RetryAPI.resetRetryCount();
      while (RetryAPI.performRetry()) {
        getCoverage = await this.getMemberCoverageSummary(
          MemberCoverageSummary.getSelectedItem(),
        );
        if (RetryAPI.getResponseReceived()) break;
      }

      if (RetryAPI.retryFailed()) {
        const errorCode = RetryAPI.getErrorCode();
        HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');
        this.setState({ selectedFlag: false }); //CREATE A NEW FLAG TO DISPLAY ERROR MESSAGE

        //Process Client Errors
        if (
          HttpErrorHandler.ProcessedClientErrors(
            errorCode,
            'view member coverage summary. ',
          )
        ) {
          console.log('INSIDE PROCESSED CLIENT ERRORS');
          this.setState({ clientError: true });
          this.setState({ selectedFlag: true });
        } else {
          //Handle Excpetion
          if (
            HttpErrorHandler.ProcessedException(
              errorCode,
              'We are unable to render your Coverage Summary now.',
            )
          ) {
            this.setState({ serverError: true });
          }
        }
      } else {
        RetryAPI.setResponseReceived(false);
        RetryAPI.resetRetryCount();
        while (RetryAPI.performRetry()) {
          getAccums = await this.getAccumulatorDetails(
            MemberCoverageSummary.getSelectedItem(),
          );
          if (RetryAPI.getResponseReceived()) break;
        }

        if (RetryAPI.retryFailed()) {
          const errorCode = RetryAPI.getErrorCode();
          HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');
          this.setState({ selectedFlag: false }); //CREATE A NEW FLAG TO DISPLAY ERROR MESSAGE
          //EVERY COVERAGE WILL HAVE A ACCUMULATOR HENCE NO 404 ERROR CHECK REQUIRED
          //Process Client Errors
          if (
            HttpErrorHandler.ProcessedClientErrors(
              errorCode,
              'view accumulator details. ',
            )
          ) {
            console.log('INSIDE PROCESSED CLIENT ERRORS');
            this.setState({ clientError: true });
            this.setState({ selectedFlag: true });
          } else {
            //Handle Excpetion
            if (
              HttpErrorHandler.ProcessedException(
                errorCode,
                'We are unable to render your Coverage Summary now.',
              )
            ) {
              this.setState({ serverError: true });
            }
          }
        } else {
          this.setState({ selectedFlag: true });
        }
      }
      //}
      //else
      //{
      //this.setState({selectedFlag:true});
      //}
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { alignCenter } = prevState;
    const { alignCenter: alignCenterNew } = this.state;
    if (alignCenter !== alignCenterNew) {
      this.menu.setInitial();
    }
  }

  setSelected = (ev) => {
    const { value } = ev.target;
    this.setState({ selected: String(value) });
    console.log('onSelect');
  };

  renderElement() {
    for (let iIndex = 0; iIndex < list?.length; iIndex++) {
      if (list[iIndex].name == this.state.selected) {
        MemberCoverageSummary.setSelectedItem(iIndex);
        return <CoverageSlider />;
      }
    }

    return (
      <div className="h-100 coverage-red text-center">
        {this.state.selected} : No matching records found
      </div>
    );
  }

  render() {
    const {
      alignCenter,
      clickWhenDrag,
      hideArrows,
      dragging,
      hideSingleArrow,
      itemsCount,
      scrollToSelected,
      selected,
      translate,
      transition,
      wheel,
    } = this.state;

    const menu = this.menuItems;

    const { t } = this.props;

    const checkboxStyle = {
      margin: '5px 10px',
    };
    /*
    const valueStyle = {
      margin: '5px 10px',
      display: 'inline-block'
    };
    */

    if (this.state.serverError)
      return <Navigate to="/member/server-error" push={true}></Navigate>;

    return (
      <div className="App">
        <div className="coverage-head-background coverage_dropdown d-block d-sm-none">
          <h3 className="m-0">{t('member.pages.coverages.coverage_status')}</h3>
          {this.state.selectedFlag && (
            <div>
              <Form.Label>
                {t('member.pages.coverages.view_coverage_for')}
              </Form.Label>
              <Form.Control
                label="View coverage for"
                as="select"
                name="dependent"
                value={selected}
                onChange={(e) => this.onSelect(e.currentTarget.value)}
              >
                {list.map((item) => (
                  <option key={item.name} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </Form.Control>
            </div>
          )}
        </div>
        <div>
          <Card>
            <div className="coverage-head-background d-none d-sm-block">
              <h3 className="m-0">
                {t('member.pages.coverages.coverage_status')}
              </h3>
              {this.state.selectedFlag && (
                <ScrollMenu
                  alignCenter={alignCenter}
                  arrowLeft={menu?.length > 6 ? ArrowLeft : ArrowHide}
                  arrowRight={menu?.length > 6 ? ArrowRight : ArrowHide}
                  clickWhenDrag={clickWhenDrag}
                  data={menu}
                  dragging={dragging}
                  hideArrows={hideArrows}
                  hideSingleArrow={hideSingleArrow}
                  onFirstItemVisible={this.onFirstItemVisible}
                  onLastItemVisible={this.onLastItemVisible}
                  onSelect={this.onSelect}
                  onUpdate={this.onUpdate}
                  ref={(el) => (this.menu = el)}
                  scrollToSelected={scrollToSelected}
                  selected={selected}
                  transition={+transition}
                  translate={translate}
                  wheel={wheel}
                  tabIndex={0}
                />
              )}
            </div>
            <div className="dashboard-carousel">
              {
                !this.state.selectedFlag && (
                  <Row className="ml-0">
                    {Array(3)
                      .fill()
                      .map((ele) => {
                        return (
                          <>
                            <Col className="p-4" md="4">
                              <Row className="border-bottom row text-center justify-content-center align-items-center p-4">
                                <Col className="text-center justify-content-center">
                                  <Skeleton count={1} className="w-50" />
                                  <Skeleton
                                    count={1}
                                    style={{ width: '70%', height: '20px' }}
                                  />
                                </Col>
                                <Col className="text-center justify-content-center">
                                  <Skeleton
                                    count={1}
                                    circle
                                    className="mb-4"
                                    style={{ width: '100px', height: '100px' }}
                                  />
                                  <Skeleton count={1} className="w-50" />
                                  <Skeleton
                                    count={1}
                                    className="w-50"
                                    style={{ height: '20px' }}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col className="text-left  justify-content-center">
                                  <Skeleton count={1} className="w-50" />
                                  <Skeleton count={1} className="w-50" />
                                  <Skeleton
                                    count={1}
                                    className="w-50"
                                    style={{ height: '20px' }}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </>
                        );
                      })}
                  </Row>
                )
                //<Card className="coverage-card p-2">

                //{/* <Loader className="font-weight-bold loader-color" size='large' aria-live='assertive' active >Loading Coverage Status 3   for {memberName}...</Loader> */}
                //<Skeleton count={10} />
                //</Card>
              }
              {this.state.selectedFlag && !this.state.clientError && (
                <>{this.renderElement()}</>
              )}
            </div>

            {this.state.selectedFlag && this.state.isAPIFailed ? (
              <Container className="px-0">
                {this.state.isNotFound ? (
                  <CustomClientError
                    ErrorHeading="No Coverages found!"
                    ErrorMessage="The selected Member does not have any Coverage Summary."
                  />
                ) : (
                  <CustomClientError
                    ErrorHeading="Something went wrong with request!"
                    ErrorMessage="Please try again."
                  />
                )}
              </Container>
            ) : (
              <></>
            )}
          </Card>
        </div>
      </div>
    );
  }
}

export default withTranslation()(MenuTabs);
